import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=387dc476&"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387dc476')) {
      api.createRecord('387dc476', component.options)
    } else {
      api.reload('387dc476', component.options)
    }
    module.hot.accept("./VerticalNavMenuItem.vue?vue&type=template&id=387dc476&", function () {
      api.rerender('387dc476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/vertical-nav-menu/VerticalNavMenuItem.vue"
export default component.exports